/**
 * Save a Blob as a file download. The file name is chosen here: cross-origin scripts cannot read the server's
 * Content-Disposition unless the backend exposes it.
 */
export function saveBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 0);
}
